// CSS
import { Box, Skeleton, Stack } from "@mui/material";
import "../Brief.css";
import "swiper/css";

interface propsType {}

const BriefSkeleton = (props: propsType) => {
  return (
    <>
      <section id="commWrap" className="brief">
        <article className="article-01">
          <div className="brief-wrap">
            <div className="pc-img-wrap">
              <div className="img-wrap">
                <Box sx={{ display: "flex", justifyContent: "center" }}>
                  <Skeleton variant="rounded" width={"100%"} height={350} />
                </Box>
              </div>
            </div>
            <div className="brief-cont">
              <div className="brief-text">
                <div className="brief-info">
                  <ul>
                    <li>
                      <Skeleton variant="rounded" width={300} height={32} />
                    </li>
                  </ul>
                </div>
                <dl>
                  <dt>
                    <Skeleton variant="rounded" width={"100%"} height={40} />
                  </dt>
                  <dd className="white-space-pre-line">
                    <Stack direction="column" spacing={1}>
                      <Skeleton variant="rounded" width={"100%"} height={30} />
                      <Skeleton variant="rounded" width={"100%"} height={30} />
                      <Skeleton variant="rounded" width={"100%"} height={30} />
                      <Skeleton variant="rounded" width={"100%"} height={30} />
                    </Stack>
                  </dd>
                </dl>
              </div>
              <div className="brief-insight">
                <dl>
                  <dt>
                    <Skeleton variant="rounded" width={300} height={32} />
                  </dt>
                  <dd className="white-space-pre-line">
                    <Stack direction="column" spacing={1}>
                      <Skeleton variant="rounded" width={"100%"} height={30} />
                      <Skeleton variant="rounded" width={"100%"} height={30} />
                      <Skeleton variant="rounded" width={"100%"} height={30} />
                      <Skeleton variant="rounded" width={"100%"} height={30} />
                    </Stack>
                  </dd>
                </dl>
              </div>
            </div>
          </div>
        </article>
      </section>
    </>
  );
};

export default BriefSkeleton;
